// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"76":"actioncable","349":"email-editor","552":"chartjs","604":"dynamic-editor","714":"markdown-editor"}[chunkId] || chunkId) + ".chunk.js";
};